<div class="list-buttons">
  <div class="list-buttons-item" *ngFor="let item of data; index as i">
    <button attr.aria-label="Abrir {{item.title}}" attr.id="{{id}}{{i}}" role="button" tabindex="0" (click)="sendItem(item, i)">
      <img src="/assets/images/svg/list-button-icon.svg" alt="icon" aria-hidden="true">
      <span aria-hidden="true">{{item.title}}</span>
      <img src="/assets/images/svg/arrow-right-dark.svg" alt="icon" aria-hidden="true" class="arrow-right">
    </button>
  </div>
</div>